import { revision, version } from '../../../package.json';
import { TLoaderVersion } from '../../types';

/**
 * Get the version of the Comgate Checkout Loader
 */
export function getLoaderVersion(): TLoaderVersion {
    return {
        version,
        revision,
    };
}
